import React, { useState,useEffect, useRef } from "react";
import AnimatedCounter from "../AnimatedCounter";
import emailjs from "@emailjs/browser";
import FeedBack from './FeedBack'

emailjs.init("bLFiDF6M6j56PCrh4");
function Home() {
  const teamGridRef = useRef(null);
  const techGridRef = useRef(null);
 const formRef = useRef();
const [menuOpen, setMenuOpen] = useState(false);
  const [formData, setFormData] = useState({
    type: "",
    contact: "",
    details: "",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    }); 
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_btdxalz",
        "template_92wbmpt",
        formRef.current,
        "bLFiDF6M6j56PCrh4"
      )
      .then(
        () => {
          alert("Feedback sent successfully!");

          setFormData({
            type: "",
            contact: "",
            details: "",
          });
        },
        (error) => {
          console.log(error);
          alert("Failed to send feedback");
        }
      );
  };


  const teamMembers = [
    {
      id: 1,
      name: "Patrick Theuri",
      title: "Director SDC",
      titleClass: "text-success",
      image:
        "/images/WhatsApp_Image_2025-07-08_at_16.15.20_f2c0cfa7-removebg-preview (1).png",
      linkedin: "#",
      github: "#",
      website: "#",
    },
    {
      id: 2,
      name: "Daniel Wanyoike",
      title: "Software Developer",
      titleClass: "text-success",
      image:
        "/images/WhatsApp Image 2025-07-07 at 16.04.06_01dad4aa.jpg",
      linkedin: "#",
      github: "#",
      website: "#",
    },
    {
      id: 3,
      name: "Eliud Kamau",
      title: "Software Developer",
      titleClass: "text-success",
      image: "/images/staff-5.jpg",
      linkedin: "#",
      github: "#",
      website: "#",
    },
    {
      id: 4,
      name: "Milton Omondi",
      title: "Software Developer",
      titleClass: "text-success",
      image:
        "/images/WhatsApp Image 2025-07-07 at 11.47.05_68f7f481.jpg",
      linkedin: "#",
      github: "#",
      website: "#",
    },
    {
      id: 5,
      name: "Sally Gitonga",
      title: "Software Developer",
      titleClass: "text-success",
      image:
        "/images/WhatsApp Image 2025-07-03 at 12.19.37_67a16ec0.jpg",
      linkedin: "#",
      github: "#",
      website: "#",
    },
    {
      id: 6,
      name: "Aaron Bett",
      title: "Software Developer",
      titleClass: "text-success",
      image:
        "/images/WhatsApp Image 2025-07-07 at 15.00.45_fbc1c5b2.jpg",
      linkedin: "#",
      github: "#",
      website: "#",
    },
    {
      id: 7,
      name: "David Wanjogu",
      title: "Software Developer",
      titleClass: "text-success",
      image: "/images/david.jpg",
      linkedin: "#",
      github: "#",
      website: "#",
    },
    {
        id: 8,
        name: "Joyce Gatura",
        title: "Software Developer",
        titleClass: "text-success",
        image: "/images/joyce.jpeg",
        linkedin: "#",
        github: "#",
       website: "#",
    },
    {
        id: 9,
        name: "Gloria Nyambura",
        title: "Software Developer",
        titleClass: "text-success",
        image: "/images/gloria.jpeg",
        linkedin: "#",
        github: "#",
        website: "#",
    }
  ];

  const cloneTeamMembers = () => {
    return [...teamMembers, ...teamMembers];
  };

  useEffect(() => {
    const scrollAmount = 1;
    const scrollInterval = 25;

    const scrollElement = (elementRef) => {
      if (elementRef.current) {
        const scrollPosition = elementRef.current.scrollLeft;
        const containerWidth = elementRef.current.offsetWidth;
        const totalScrollWidth = elementRef.current.scrollWidth;

        elementRef.current.scrollLeft += scrollAmount;

        if (scrollPosition + containerWidth >= totalScrollWidth) {
          elementRef.current.scrollLeft = 0;
        }
      }
    };

    const interval = setInterval(() => {
      scrollElement(teamGridRef);
      scrollElement(techGridRef);
    }, scrollInterval);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const blocks = document.querySelectorAll(".info-block");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("active");
          }
        });
      },
      { threshold: 0.2 }
    );

    blocks.forEach((block) => observer.observe(block));

    return () => {
      blocks.forEach((block) => observer.unobserve(block));
    };
  }, []);
  useEffect(() => {
  const canvas = document.createElement('canvas');
  canvas.style.cssText = 'position:fixed;top:0;left:0;pointer-events:none;z-index:99999';
  document.body.appendChild(canvas);
  const ctx = canvas.getContext('2d');
  let W = canvas.width = window.innerWidth;
  let H = canvas.height = window.innerHeight;
  let particles = [];

  window.addEventListener('resize', () => {
    W = canvas.width = window.innerWidth;
    H = canvas.height = window.innerHeight;
  });

  window.addEventListener('mousemove', (e) => {
    for (let i = 0; i < 5; i++) {
      particles.push({
        x: e.clientX, y: e.clientY,
        vx: (Math.random() - 0.5) * 3,
        vy: (Math.random() - 0.5) * 3 - 1,
        life: 1,
        size: Math.random() * 4 + 2,
        color: ['#cdd83b', '#0092d7', '#ffffff'][Math.floor(Math.random() * 3)],
      });
    }
  });

  const animate = () => {
    ctx.clearRect(0, 0, W, H);
    particles = particles.filter(p => p.life > 0);
    particles.forEach(p => {
      p.x += p.vx; p.y += p.vy;
      p.vy += 0.05;
      p.life -= 0.03;
      ctx.save();
      ctx.globalAlpha = p.life;
      ctx.fillStyle = p.color;
      ctx.beginPath();
      // Draw a 4-point star
      const s = p.size;
      ctx.moveTo(p.x, p.y - s);
      ctx.lineTo(p.x + s * 0.3, p.y - s * 0.3);
      ctx.lineTo(p.x + s, p.y);
      ctx.lineTo(p.x + s * 0.3, p.y + s * 0.3);
      ctx.lineTo(p.x, p.y + s);
      ctx.lineTo(p.x - s * 0.3, p.y + s * 0.3);
      ctx.lineTo(p.x - s, p.y);
      ctx.lineTo(p.x - s * 0.3, p.y - s * 0.3);
      ctx.closePath();
      ctx.fill();
      ctx.restore();
    });
    requestAnimationFrame(animate);
  };
  animate();

  return () => { document.body.removeChild(canvas); };
}, []);

const heroImages = [
  "/images/group.jpeg",
  "/images/domenico-loia-EhTcC9sYXsw-unsplash.jpg",
  // add more as needed
];
const [heroIndex, setHeroIndex] = useState(0);

useEffect(() => {
  const timer = setInterval(() => {
    setHeroIndex(i => (i + 1) % heroImages.length);
  }, 4500);
  return () => clearInterval(timer);
}, []);

  return (
    <div>
      {/* HERO SECTION */}
      <section className="hero-section" id="home">
  {heroImages.map((src, i) => (
    <img
      key={src}
      src={src}
      alt="SDC Office"
      className="hero-bg"
      style={{
        position: i === 0 ? 'relative' : 'absolute',
        top: 0, left: 0,
        opacity: i === heroIndex ? 1 : 0,
        transition: 'opacity 1s ease',
        zIndex: i === heroIndex ? 1 : 0,
      }}
    />
  ))}

<header className="main-header" style={{ zIndex: 20 }}>
  <div className="logo">
    <img src="/images/SDC3-01-1.png" alt="SDC Logo" />
  </div>

  {/* Desktop nav */}
  <nav className="desktop-nav">
    <a href="#home">HOME</a>
    <a href="#about">ABOUT US</a>
    <a href="#services">SERVICES</a>
    <a href="#projects">PROJECTS</a>
    <a href="#contact">CONTACT</a>
    <a href="/manuals">PORTAL MANUALS</a>
  </nav>

  {/* Hamburger button — mobile only */}
  <button
    className="hamburger"
    onClick={() => setMenuOpen(o => !o)}
    aria-label="Toggle navigation"
  >
    <span className={`ham-bar ${menuOpen ? 'open-1' : ''}`} />
    <span className={`ham-bar ${menuOpen ? 'open-2' : ''}`} />
    <span className={`ham-bar ${menuOpen ? 'open-3' : ''}`} />
  </button>

  {/* Mobile drawer */}
  {menuOpen && (
    <div className="mobile-nav" onClick={() => setMenuOpen(false)}>
      <a href="#home">HOME</a>
      <a href="#about">ABOUT US</a>
      <a href="#services">SERVICES</a>
      <a href="#projects">PROJECTS</a>
      <a href="#contact">CONTACT</a>
      <a href="/manuals">MANUALS</a>
    </div>
  )}
</header>

        <div className="hero-overlay hero-overlay-right">
          <h1>
            Agile, transparent, and customer-focused –
            <br />
            we deliver quality code on time, every time.
          </h1>

          <p className="for-apps">
            <span>For, </span>
            <span className="highlight">Website Applications</span>
          </p>

          <button className="quote-btn">
            <a href="#contact" style={{ color: "inherit", textDecoration: "none" }}>
            Request a Quote
            </a>

            <span className="arrow-circle">
              <svg
                width="36"
                height="36"
                viewBox="0 0 36 36"
                fill="none"
              >
                <circle cx="18" cy="18" r="18" fill="white" />

                <path
                  d="M13 18H23"
                  stroke="black"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                />

                <path
                  d="M20.5 15.5L23 18L20.5 20.5"
                  stroke="black"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                />
              </svg>
            </span>
          </button>
        </div>

        {/* Carousel dots */}
  <div style={{
    position: 'absolute', bottom: 30, left: '50%',
    transform: 'translateX(-50%)', display: 'flex', gap: 10, zIndex: 20
  }}>
    {heroImages.map((_, i) => (
      <button
        key={i}
        onClick={() => setHeroIndex(i)}
        style={{
          width: i === heroIndex ? 28 : 10, height: 10,
          borderRadius: 10, border: 'none', cursor: 'pointer',
          background: i === heroIndex ? '#cdd83b' : 'rgba(255,255,255,0.5)',
          transition: 'all 0.3s ease', padding: 0,
        }}
        aria-label={`Go to slide ${i + 1}`}
      />
    ))}
  </div>
      </section>

      {/* ABOUT */}
      <section className="about-section" id="about">
        <div className="about-img">
          <img
            src="/images/domenico-loia-EhTcC9sYXsw-unsplash.jpg"
            alt="Workspace"
          />
        </div>

        <div className="about-content">
          <h2>
            About Us
            <span className="underline" />
          </h2>

          <p>
            Software Development Center (SDC) is a provider of
            software development services based in Dedan Kimathi
            University of Technology.
            <br />
            Founded in 2019 and ever since we have developed
            software solutions for the university hence improving
            the smooth running of the university.
          </p>

          <a className="contact-btn" href="#contact">
            CONTACT US
          </a>
        </div>
      </section>

      {/* IMPACT */}
      <section className="impact-bar" id="impact">
        <div className="impact-col">
          <span
            className="impact-title"
            style={{ fontFamily: "Georgia" }}
          >
            Our Impact
          </span>
        </div>

        <div className="impact-col">
          <span
            className="impact-num"
            style={{ color: "white" }}
          >
            <AnimatedCounter end={30} duration={1000} />+
          </span>

          <span className="impact-label">Projects</span>
        </div>

        <div className="impact-col">
          <span
            className="impact-num"
            style={{ color: "white" }}
          >
            <AnimatedCounter end={20} duration={1000} />+
          </span>

          <span className="impact-label">Clients</span>
        </div>
      </section>

      {/* MISSION */}
      <div className="container py-5" id="mission">
        <section className="mission-vision-section">
          <div className="mission-row">
            <div className="section-title">
              <h2>
                Our Mission &amp;
                <br />
                Vision
              </h2>
            </div>

            <div className="info-block animate-right mission-block">
              <div className="icon">
                <img
                  src="/images/strategy.png"
                  alt="Mission Icon"
                />
              </div>

              <div className="content">
                <span>Mission</span>

                <p>
                  To design, develop, customize, and maintain
                  software with the aim of improving individual
                  and business productivity.
                </p>
              </div>
            </div>
          </div>

          <div className="info-block animate-left vision-block">
            <div className="content">
              <span>Vision</span>

              <p>
                To be a leader in the provision of locally
                developed and customized software solutions.
              </p>
            </div>

            <div className="reverse-icon">
              <img
                src="/images/strategy.png"
                alt="Vision Icon"
              />
            </div>
          </div>
        </section>
      </div>

      {/* TEAM */}
      <section className="team-section-custom" id="team">
        <div className="team-content">
          <div className="team-intro">
            <h2>Our Team</h2>

            <p>
              At the heart of the Software Development Centre is
              a passionate team of innovators and developers.
            </p>
          </div>

          <div className="team-grid" ref={teamGridRef}>
            {cloneTeamMembers().map((member, index) => (
              <div
                key={`${member.id}-${index}`}
                className="team-card"
              >
                <div className="team-image">
                  <img
                    src={member.image}
                    alt={member.name}
                  />
                </div>

                <div className="team-info">
                  <h3>{member.name}</h3>

                  <p className="team-title">
                    {member.title}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="tech-section">
          <div className="tech-grid" ref={techGridRef}>
            <div className="tech-logos">
            {[
              { name: 'csharp', image: 'images/png-transparent-c-sharp-c-net-object-oriented-programming-language-microsoft-3d-icon-removebg-preview.png' },
              { name: 'react', image: 'images/react.png' },
              { name: 'laravel', image: 'images/i_m_bi_production_blanks_vdbwo35fw6qtflw9kezw_1565806151_c_156_164_x779_bc_000000_s_630_q_90-removebg-preview.png' },
              { name: 'angular', image: 'images/angula.png' },
              { name: 'nodejs', image: 'images/node.png' },
                { name: 'javascript', image: 'images/javascript.png' },
                { name: 'php', image: 'images/php.png' },
                { name: '.net', image: 'images/Net.png' },
                { name: 'yii', image: 'images/yii.png' },
                { name: 'next', image: 'images/next.png' },
                { name: 'react native', image: 'images/React_Native.png' }
            ].map((tech) => (
              <img
                key={tech.name}
                src={tech.image}
                alt={tech.name}
                className="tech-logo"
              />
            ))}
          </div>
          </div>
        </section>
        <section className="services-section" id="services">
  <div className="services-header">
    <span className="services-eyebrow">What we do</span>
    <h2>Services we offer</h2>
    <p>Tailored digital solutions built for lasting impact — from idea to delivery.</p>
  </div>

  <div className="services-grid-new">
    {[
      { icon: 'ti-desktop', title: 'Microsoft 365 Customization', desc: 'Customize and optimize your Microsoft 365 suite for seamless collaboration and productivity.' },
      { icon: 'ti-world-www', title: 'Website Development', desc: 'We have created and delivered software solutions across education, finance, and healthcare.' },
      { icon: 'ti-device-mobile', title: 'Mobile App Development', desc: 'We listen to your ideas and build custom mobile applications designed for your organisation.' },
      { icon: 'ti-school', title: 'Student Mentorship', desc: 'We help you discover what to learn and why — it is time to invest in yourself.' },
      { icon: 'ti-plug-connected', title: 'API Integration', desc: 'Our team analyses your project\'s functionality, business logic, and future user scenarios.' },
      { icon: 'ti-layout-dashboard', title: 'Management Systems', desc: 'Creating workload and operations management systems for academic and enterprise planning.' },
      { icon: 'ti-settings', title: 'System Maintenance', desc: 'Rigorous quality assurance checks to ensure your organisation runs efficiently.' },
      { icon: 'ti-pencil-code', title: 'Software Design & Build', desc: 'Designing and building bespoke software solutions for university and enterprise operations.' },
      // { icon: 'ti-handshake', title: 'Partnering', desc: 'Partnering with enterprises and communities in Kenya to deliver digital transformation.' },
    ].map((s, i) => (
      <div key={i} className="service-card-new">
        <div className="service-icon-new">
          <i className={`ti ${s.icon}`} aria-hidden="true" />
        </div>
        <h3>{s.title}</h3>
        <p>{s.desc}</p>
      </div>
    ))}
  </div>
</section>
            <section className="projects-section" id="projects">
          <h2>
            Our Projects
            <span className="underline" />
          </h2>
          <div className="projects-list">
            <div className="project-card">
              <img src="images\erp.png" alt="Workload Website" />
              <div className="project-label">Microsoft 365</div>
              <p className="project-desc">
                The Microsoft 365 solution helps streamline operations and improve productivity across different departments...
              </p>
              <a href="">Continue reading →</a>
            </div>
            <div className="project-card">
              <img src="images\cafe.png" alt="Cafeteria Website" />
              <div className="project-label">Cafeteria Management
                <span className="label-strip"></span>
              </div>
              <p className="project-desc">
                The cafeteria website offers a seamless platform for ordering meals, viewing ....
              </p>
              <a href="">Continue reading →</a>
            </div>
            <div className="project-card">
              <img src="images\workman.png" alt="Workload Website" />
              <div className="project-label">Workload Management</div>
              <p className="project-desc">
                The workload management system helps streamline operations and improve efficiency...
              </p>
              <a href="">Continue reading →</a>
            </div>
            <div className="project-card">
              <img src="images\mwai kibaki.png" alt="Hospital Mgt System" />
              <div className="project-label">Hospital Management</div>
              <p className="project-desc">
                The hospital management system helps streamline operations and improve patient care...
              </p>
              <a href="">Continue reading →</a>
            </div>
             <div className="project-card">
              <img src="images\biodata.png" alt="Cafeteria Website" />
              <div className="project-label">Biodata Management
                <span className="label-strip"></span>
              </div>
              <p className="project-desc">
                The biodata management system helps streamline operations and improve data accuracy...
              </p>
              <a href="">Continue reading →</a>
            </div>
            <div className="project-card">
              <img src="images\staffportal.png" alt="Workload Website" />
              <div className="project-label">Students and Staff Management</div>
              <p className="project-desc">
                The students and staff management system helps streamline operations and improve accessibility of data...
              </p>
              <a href="">Continue reading →</a>
            </div>
            {/* <div className="project-card">
              <img src="images\mwai kibaki.png" alt="Hospital Mgt System" />
              <div className="project-label">Hospital Management</div>
              <p className="project-desc">
                The cafeteria website offers a seamless platform for ordering meals, viewing ....
              </p>
              <a href="">Continue reading →</a>
            </div> */}
          </div>
        </section>
        <section className="form-section" id="form">
          <div className="form-image">
            <img src="images\Feedback-amico.png" alt="Feedback Illustration" style={{ maxWidth: '100%', height: 'auto' }} />
          </div>

      {/* <div className="form-content" id="contact">
      <h2>Submit Your Feedback</h2>
      <p>
        In case of Compliments, Complaints, or Reporting Corruption Cases
      </p>

      <form ref={formRef} onSubmit={handleSubmit}>
      <label>Select Feedback Type</label>

      <input
        type="text"
        name="type"
        value={formData.type}
        onChange={handleChange}
        required
      />

      <label>Your Name/Email (Optional)</label>

      <input
        type="text"
        name="contact"
        value={formData.contact}
        onChange={handleChange}
      />

      <label>Details</label>

      <textarea
        name="details"
        rows="5"
        value={formData.details}
        onChange={handleChange}
        required
      ></textarea>

      <button type="submit">SUBMIT</button>
    </form>
  
    </div> */}



    <FeedBack/>




        </section>
        <section
  id="manuals"
  style={{
    padding: "120px 7%",
    background: "#eef6fb", // soft blue
    textAlign: "center",
    borderTop: "1px solid #d7e8f3",
  }}
>

  <h2
    style={{
      fontSize: "2.3rem",
      fontWeight: "700",
      color: "#003366",
      marginBottom: "10px",
      
    }}
  >
    Portal User Manuals
  </h2>

  <p
    style={{
      maxWidth: "700px",
      margin: "0 auto 50px",
      color: "#555",
      fontSize: "16px",
      lineHeight: "1.7",
    }}
  >
    Download the appropriate user manual to learn how to access and use the
    Students and Staff Portal.
  </p>

  <div
    style={{
      display: "flex",
      justifyContent: "center",
      flexWrap: "wrap",
      gap: "30px",
    }}
  >
    {/* Staff Manual */}
    <div
      style={{
        background: "#fff",
        width: "340px",
        padding: "35px 25px",
        borderRadius: "16px",
        boxShadow: "0 10px 25px rgba(0,0,0,0.08)",
        transition: "0.3s",
      }}
    >
      <div style={{ fontSize: "60px", marginBottom: "20px" }}>📘</div>

      <h3
        style={{
          color: "#003366",
          marginBottom: "15px",
        }}
      >
        Staff Portal Manual
      </h3>

      <p
        style={{
          color: "#666",
          lineHeight: "1.6",
          marginBottom: "25px",
        }}
      >
        Step-by-step guide for staff members on logging in, changing passwords,
        and using the Staff Portal.
      </p>

      <a
        href="/docs/STAFF PORTAL LOGIN GUIDE.pdf"
        target="_blank"
        rel="noopener noreferrer"
        style={{
          display: "inline-block",
          background: "#0092d7",
          color: "#fff",
          padding: "12px 28px",
          borderRadius: "30px",
          textDecoration: "none",
          fontWeight: "600",
        }}
      >
        View Staff Manual
      </a>
    </div>

    {/* Student Manual */}
    <div
      style={{
        background: "#fff",
        width: "340px",
        padding: "35px 25px",
        borderRadius: "16px",
        boxShadow: "0 10px 25px rgba(0,0,0,0.08)",
      }}
    >
      <div style={{ fontSize: "60px", marginBottom: "20px" }}>🎓</div>

      <h3
        style={{
          color: "#003366",
          marginBottom: "15px",
        }}
      >
        Student Portal Manual
      </h3>

      <p
        style={{
          color: "#666",
          lineHeight: "1.6",
          marginBottom: "25px",
        }}
      >
        Learn how to log in, change your password, and access all features
        available in the Student Portal.
      </p>

      <a
        href="/docs/STUDENT PORTAL LOGIN GUIDE.pdf"
        target="_blank"
        rel="noopener noreferrer"
        style={{
          display: "inline-block",
          background: "#cdd83b",
          color: "#000",
          padding: "12px 28px",
          borderRadius: "30px",
          textDecoration: "none",
          fontWeight: "600",
        }}
      >
        View Student Manual
      </a>
    </div>
  </div>
</section>

      {/* FOOTER */}
        <section className="footer-section" id="footer">
          <footer className="footer">
            <div className="footer-logo">
              <img src="images\SDC3-01-1.png" alt="Logo" />
              <p className="footer-brand">Software Development Centre</p>
            </div>
            <div>
              <h3>Site Links</h3>
              <ul>
                <li><a href="#home">Home</a></li>
                <li><a href="#about">About Us</a></li>
                <li><a href="#services">Services</a></li>
                <li><a href="#projects">Projects</a></li>
                <li><a href="#contact">Contact</a></li>
                <li><a href="/manuals">Manuals</a></li>
              </ul>
            </div>
            <div>
              <h3>Contacts</h3>
              <p>sdc@dkut.ac.ke</p>
            </div>
            <div>
              <h3>Code of Ethics</h3>
              <p>Software Development <br></br>Centre is a corruption-free zone and maintains a zero-tolerance policy on drug use, fostering integrity and professionalism.</p>
            </div>
            <div>
              <h3>Location</h3>
              <p>Dedan Kimathi University Of Technology - Resource Centre</p>
            </div>
          </footer>
          <div className="copyright">
            <p>@Copyright 2026. All Rights Reserved. Software Development Centre</p>
          </div>
        </section>
    </div>
  );
}

export default Home;